// Centralized export of shared services
export { portfolioApi } from './portfolioApi';
//  fix - Default import instead of named import
export { default as apiService } from './apiService';  // ✅ Default export
export { imageService } from './imageService';

// Export of card services (localStorage) - educationCardsService removed (backend-first)

// Export of synchronization services

// Export of card types (Education via UI types)
export type { EducationCard, EducationCardCreate, EducationCardUpdate } from '../types/education';
// experienceCardsService removed (backend-first)

// Export of synchronization types
// Education types (display) removed with the deletion of the sync service
// experienceSyncService removed (backend-first)

// Export of specialized API services
export { aboutApi } from './api/aboutApi';
export { assetsApi } from './api/assetsApi';
export { authApi } from './api/authApi';
export { educationApi } from './api/educationApi';
export { hobbiesApi } from './api/hobbiesApi';
export { lifeQuotesApi } from './api/lifeQuotesApi';
export { projectsApi } from './api/projectsApi';
export { sectionsApi } from './api/sectionsApi';
export { systemApi } from './api/systemApi';

//  fix - Correct import
import { portfolioApi as portfolioApiService } from './portfolioApi';
import { hobbiesApi } from './api/hobbiesApi';

export const portfolioApiWithHobbies = {
  ...portfolioApiService,
  hobbies: hobbiesApi
};

// Export of types from the right place
export type {
  ApiResponse,
  User,
  Project,
  Section,
  AboutInfo,
  EducationItem,
  HobbyItem,
  LifeQuoteItem,
  AssetData,
  ValidationResult,
  ValidationError
} from '../types/index';
